export enum DraftEntryPoint {
  RecentDraftsCarousel = 'recent_drafts_carousel',
  MatterActivity = 'matter_activity',
  DraftsPage = 'drafts_page',
}
